import React from 'react';
export function SiteHeader() {
  return <header className="relative mx-auto flex w-full max-w-[1280px] items-center px-6 pt-8 sm:px-10 sm:pt-10" data-id="element-70" data-mp="235tvohsmro4z">
      <img src="https://cdn.magicpatterns.com/uploads/2GY4Rj3h4RKeLCXMSEW7UC/651c1216616124d1aa4509c0_Boss_Logo_1.svg" alt="BOSS" width={196} height={56} className="h-12 w-auto sm:h-14" data-id="element-71" data-mp="36zrcctx1turr" />
    </header>;
}